export default __webpack_public_path__ + "static/media/DeweyBlue_Panicum_Grass.063a19bd.png";